import { ReadingJournalPositionType } from "features/ReadingJournal/types";
import Icon from "hardcover-ui/components/Icon";
import { textReadingFormat } from "types/ReadingFormatType";

export default function ReadingJournalPositionPages({
  position,
}: {
  position: ReadingJournalPositionType;
}) {
  return (
    <span className="flex flex-row items-center space-x-2">
      <Icon icon={textReadingFormat.iconRegular} />
      <span>p. {position.value.toLocaleString()}</span>
    </span>
  );
}
